import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';
import { formatCompact } from './format';

/** Used against allowed: a hairline bar that turns amber at 80% and red at 100%. -1 = unlimited. */
export function QuotaBar({ used, limit, className }: { used: number; limit: number; className?: string }) {
  const { t } = useTranslation();
  if (limit < 0) {
    return (
      <span className={cn('text-xs text-muted-foreground tabular-nums', className)}>
        {formatCompact(used)} · {t('ADMIN_SHELL.COMMON.UNLIMITED')}
      </span>
    );
  }
  const share = limit > 0 ? used / limit : 0;
  const pct = Math.min(100, Math.round(share * 100));
  return (
    <div className={cn('flex min-w-28 items-center gap-2', className)} title={`${used} / ${limit}`}>
      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-muted" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div
          className={cn('h-full rounded-full', share >= 1 ? 'bg-destructive' : share >= 0.8 ? 'bg-warning' : 'bg-foreground/70')}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="w-9 text-end text-xs text-muted-foreground tabular-nums">{pct}%</span>
    </div>
  );
}
